import { PluralizeEntity } from '@/component/MultiEmailInput/MultiEmailInput';

/**
 * Turns a human-readable string into a lowercase, hyphenated slug: drops everything that is not a
 * letter, digit or whitespace, then collapses whitespace runs into single hyphens.
 * `'C++ & "Rust": a story!'` becomes `'c-rust-a-story'`. Used for the human-readable `:name`
 * segment of URLs and for generated file names; it is not reversible and not idempotent — running
 * it over an existing slug strips the hyphens it put there.
 */
export function slugify(title?: string): string {
  if (!title) return '';
  return title
    .replace(/[^A-Za-z0-9\s]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
}

export function clone<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}

const DisplayRealm: { [key: string]: string } = {
  cls: 'Collegial',
  campus: 'Collegial',
  fazer: 'Fazer',
  atlascopco: 'Atlas Copco',
  seb: 'SEB',
  scania: 'Scania',
  ericsson: 'Ericsson',
  saab: 'SAAB',
  wartsila: 'Wärtsilä',
  sse: 'SSE',
  epiroc: 'Epiroc',
  husqvarna: 'Husqvarna',
  storaenso: 'Stora Enso',
  electrolux: 'Electrolux',
  partner: 'Partner',
  mix: 'Mix',
  skf: 'Skf',
};

export const ENTER_CHAR_CODE = 13;

export function displayRealm(realm: string): string {
  return DisplayRealm[realm] || realm;
}

export const pickLabel = (labels?: string[]): string | undefined => {
  if (!labels || !labels.length) return;

  const visibleLabels = [
    { value: 'admin', priority: 0 },
    { value: 'moderator', priority: 1 },
    { value: 'member', priority: 2 },
  ];

  return visibleLabels
    .sort((a, b) => b.priority - a.priority)
    .map(({ value }) => value)
    .reduce((previousLabel?: string, currentLabel?: string): string | undefined => {
      return labels.find((target) => currentLabel === target) ? currentLabel : previousLabel;
    }, undefined);
};

export const pluralize = (count: number, typeEntity: PluralizeEntity): string => typeEntity[count === 0 || count > 1 ? 'p' : 's'];

export const screenSizes = {
  landscapeMin: 768,
  tabletMin: 840,
  desktopMin: 1024,
};
